module.exports = __webpack_public_path__ + "static/media/wwd_art.df2d15e3.svg";